import { useContext, useEffect, useState } from "react";
import { DataContext } from "../../context/Data.context";
import { Separator } from "@moreirapontocom/npmhelpers";
import { Link, useParams } from "react-router-dom";

const TestResult = () => {
  const { data, setData } = useContext(DataContext);
  const params: any = useParams();
  const resultHash: string = params.resultHash;

  useEffect(() => {
    setData({
      ...data,
      pageHeader: {
        title: "Test Result",
        backButton: true,
        previousPage: "/home",
      },
      hideNavbar: false,
    });

    _getResultDetails();
  }, []);

  const [result, setResult] = useState({} as any);
  const _getResultDetails = () => {
    if (!resultHash) {
      return;
    }

    const storageKey = "results";
    const resultsStorage: any = localStorage.getItem(storageKey);
    if (!resultsStorage) {
      return;
    }

    const results: any = JSON.parse(resultsStorage);
    const result: any = results.find((result: any) => result.id === resultHash);
    setResult(result);
  };

  const _sendReport = () => {
    const storageKey = "results";
    const resultsStorage: any = localStorage.getItem(storageKey);
    if (!resultsStorage) {
      return;
    }

    const results: any = JSON.parse(resultsStorage);
    const newResults: any = results.map((result: any) => {
      if (result.id === resultHash) {
        result.reported = true;
      }
      return result;
    });
    localStorage.setItem(storageKey, JSON.stringify(newResults));
    setResult({ ...result, reported: true });

    // https://report.makemytestcount.org/metrix/en?testType=Metrix&testTargets=covid,fluA,fluB&testResults=positive,negative,positive
    // testType=Metrix is causing an error
    let url = "https://report.makemytestcount.org/metrix/en?testTargets=";
    if (result.sensorType === "covid19") {
      url += "covid";
    }
    if (result.sensorType === "covidflu") {
      url += "covid,fluA,fluB";
    }
    url += "&testResults=";
    url += result.result === "positive" ? "positive" : "negative";
    window.open(url, "_blank");
    return;
  };

  return <>
    <div className="text-center">
        <img src={`/images/icon-result-${result.result}.png`} alt="" className="img-fluid" style={{ width:  "90px" }} />

        <Separator size={20} />

        <h2 className={result.result}>
          <strong className="text-uppercase">{result.result}</strong>
        </h2>

        <Separator size={20} />

        <small className="text-muted">
          {result.timestamp}
        </small>

        <Separator size={10} />

        <strong>
          {result.sensorType === "covid19" && "COVID 19"}
          {result.sensorType === "covidflu" && "COVID / FLU"}
        </strong><br />
        <strong>Reader Serial Number:</strong> {result.readerSerialNumber}<br />
        <strong>Patient Name:</strong> John Doe (?)<br />

        <Separator size={30} />

        <small className="text-muted">
          Help us track the spread of illness. Report your anonymous results to public health authorities (<a href="http://makemytestcount.org" target="_blank" rel="noopener noreferrer">MakeMyTestCount.Org</a>).
        </small>

        <Separator size={20} />
      </div>

      <div className="d-grid">
        {!result.reported && <>
          <button
            type="button"
            onClick={() => _sendReport()}
            className="btn btn-primary btn-featured">
              Report &amp; Finish
          </button>
        </>}

        {result.reported && <>
          <button type="button" disabled className="btn btn-primary btn-featured disabled">
            Report Sent
          </button>
        </>}

        <Separator size={20} />

        <Link to={"/home"} className="btn btn-primary btn-outline-featured">
          Done
        </Link>

        <Separator size={160} />
      </div>
  </>
};

export default TestResult;